export const links = {
    firstName:'Shneha',
    lastName:'Paudyal',
    github:'https://github.com/shnehapaudyal',
    linkedin:'https://www.linkedin.com/in/shneha-paudyal/',
    email:"eshnehapaudyal@gmail.com",
    repoUrl:"https://api.github.com/users/shnehapaudyal/repos"
}